var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.show_dialog,"modal":_vm.modal,"width":(_vm.width + "%"),"center":_vm.center},on:{"update:visible":function($event){_vm.show_dialog=$event},"close":_vm.closeDialog,"before-close":_vm.beforeCloseDialog}},[_c('template',{slot:"title"},[_vm._t("title")],2),_vm._v(" "),_vm._t("body")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-358b9318","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commonReform/DialogCom.vue
// module id = null
// module chunks = 